import Popup from "reactjs-popup"
import { Text, Heading, Box, Flex, Button } from 'rebass'
import { FaTimes } from 'react-icons/fa'
import Theme from '@app/styles/theme'

const Modal = (props) => {
  return (
    <Popup
      open={props.open}
      modal={true}
      position="center center"
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={props.onClose}
      contentStyle={{
        border: '1px solid lightGray',
        width: '100%',
        padding: '0',
        maxWidth: '720px'
      }}
      overlayStyle={{
        background: 'rgba(0, 0, 0, 0.1)'
      }}
    >
      <Flex
        py={4}
        flexDirection="column"
        sx={{
          position: 'relative',
          a : {
            fontSize: "inherit",
            margin: 0,
            color: Theme.colors.primary
          },
          maxHeight: ['100dvh', '90vh', '90vh'],
          height: ['100dvh', 'auto', 'auto']
        }}
      >
        <Box
          width={32}
          height={32}
          p='4px'
          onClick={props.onClose}
          sx={{
            position: 'absolute',
            top: '12px',
            right: '12px',
            cursor: 'pointer',
            zIndex: 1
          }}
        >
          <FaTimes
            color='gray'
            fontSize='24px'
          />
        </Box>
        <Box
          mb={3}
          px={[2, 3, 4]}
          sx={{
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
            lineHeight: '48px',
            flexShrink: 0
          }}
        >
          <Heading
            mb={3}
            fontSize={[2, 3, 3]}
            lineHeight='1.5'
            color='accent'
            sx={{ textTransform: 'uppercase' }}
          >
            {props.title}
          </Heading>
          <Text lineHeight='1.5'>{props.message}</Text>
        </Box>
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            minHeight: 0
          }}
          px={[2, 3, 4]}
        >
          {props.children}
        </Box>
        {
          props.actions &&
          <Flex
            mt={4}
            px={[2, 3, 4]}
            pb={['env(safe-area-inset-bottom)', 0, 0]}
            flexWrap="wrap"
            justifyContent={props.actions.length === 1 ? "center" : "space-between"}
            sx={{
              flexShrink: 0,
              borderTop: '1px solid',
              borderColor: 'lightGray',
              pt: 3
            }}
          >
            {props.actions.map(a => {
              return (
                <Button
                  width={[1, 180, 180]}
                  my={2}
                  key={a.title}
                  variant={a.class}
                  disabled={a.disabled}
                  type={a.type ? a.type : 'button'}
                  onClick={a.action}
                >{a.title}
                </Button>
              )
            })}
          </Flex>
        }
      </Flex>
    </Popup>
  )
}
export default Modal;
